import { derived, writable } from "svelte/store";
import { newAuthClient, newApiClient } from "@hitit/api";
import { storage } from "./storage";

export const token = writable("");
export const refreshToken = storage("refreshToken");
export const clientToken = writable("");
export const expiresAt = writable("");

export let auth = derived(
	[token, clientToken, refreshToken, expiresAt],
	([t, c, r, e]) => {
		return newAuthClient(
			t,
			c,
			atob(r),
			e,
			token.set,
			clientToken.set,
			(refresh) => refreshToken.set(btoa(refresh)),
			expiresAt.set
		)
	}

);

export let api = derived(auth, (auth) => {
	return newApiClient(auth.checkRefreshToken, auth.grantClient)
});
